import { ScheduleFrequency } from "@enums/scheduleFrequency.enum";
import { Model } from "@interfaces/model.interface";

export interface MaintenanceSchedule extends Model {
	generateEvent: boolean;
	lastRunDate? : Date;
	machineId: number;
	name: string;
	nextRunDate: Date;
	noticeDays: number;
	notificationEmailAddresses: string;
	scheduleFrequency: ScheduleFrequency;
	sendReminder: boolean;
	startDate: Date;
}

export class MaintenanceSchedule implements MaintenanceSchedule {
	scheduleFrequency = ScheduleFrequency.Daily;
	startDate = new Date;

	constructor(data?: Partial<MaintenanceSchedule>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}